import template from './racedaysPage.html';
import controller from './racedaysPage.controller';
import './racedaysPage.scss';

let racedaysPageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default racedaysPageComponent;
